import type { FeatureCollection, Polygon, MultiPolygon, Position } from "geojson";
import { reconstructGeoJSON } from "../../../components/helpers/JobMap/editHelpers";
import type { GeometryResult } from "../../../domain/geometry/types";
import type { UndoableCommand } from "../undoStack";

export interface EditVerticesInput {
	originalFC: FeatureCollection<Polygon | MultiPolygon>;
	featureIndex: number;
	pathIndex: number;
	editedCoords: Position[][];
}

export interface EditVerticesResult {
	command: UndoableCommand;
	updatedFC: FeatureCollection<Polygon | MultiPolygon>;
}

/**
 * Apply edited vertex coordinates back into the original FeatureCollection.
 * Uses reconstructGeoJSON to immutably replace coords at the given feature/path.
 */
export function editVerticesUseCase(
	input: EditVerticesInput,
	applyResult: (fc: FeatureCollection<Polygon | MultiPolygon>) => void,
	revert: (fc: FeatureCollection<Polygon | MultiPolygon>) => void,
): GeometryResult<EditVerticesResult> {
	const updatedFC = reconstructGeoJSON(input.originalFC, input.featureIndex, input.pathIndex, input.editedCoords);

	return {
		ok: true,
		data: {
			updatedFC,
			command: {
				label: "Edit vertices",
				execute: () => applyResult(updatedFC),
				undo: () => revert(input.originalFC),
			},
		},
	};
}
